import { ExportServicesParams } from '@kaa/api/providers';

export const ExportModalFieldNames = {
  STATUS: 'status' as keyof ExportServicesParams,
  START_DATE: 'startDate' as keyof ExportServicesParams,
  END_DATE: 'endDate' as keyof ExportServicesParams,
  FILE_EXTENSION: 'fileExtension' as keyof ExportServicesParams,
};
